module.exports = __webpack_public_path__ + "static/media/more_games_th.98cb8ba2.png";